import React from 'react';
import ReactDOM from 'react-dom';
import { createProvider } from "react-redux";
import { storeFactory } from "./store.js";
import createTeaserListApp from './apps/TeaserListApp';


let teaserListRoots = document.getElementsByClassName('teaserListRoot');

[].forEach.call(teaserListRoots,  function(teaserListRoot){
	const tags = teaserListRoot.getAttribute('data-tags');
	const limit = +teaserListRoot.getAttribute('data-limit');
	const logicalOperator = +teaserListRoot.getAttribute('data-logical-operator');
	const detailLink = teaserListRoot.getAttribute('data-detail-link');
	const allowPagination = !!+teaserListRoot.getAttribute('data-allow-pagination');
	const detailName = teaserListRoot.getAttribute('data-detail-name');
	const contentTypes = teaserListRoot.getAttribute('data-content-types');
	const favouriteLink = teaserListRoot.getAttribute('data-page-favourites');

	const storeKey = 'store_' + teaserListRoot.getAttribute('data-id');

	const CustomProvider = createProvider(storeKey);
	const TeaserListApp = createTeaserListApp(storeKey);
	const customStore = storeFactory();

	ReactDOM.render(
		<CustomProvider store={customStore}>
			<TeaserListApp
				tags={tags}
				logicalOperator={logicalOperator}
				limit={limit}
				allowPagination={allowPagination}
				detailLink={detailLink}
				detailName={detailName}
				contentTypes={contentTypes}
				favouriteLink={favouriteLink}
			/>
		</CustomProvider>,
		teaserListRoot
	);
});


// WEBPACK FOOTER //
// ./src/teaserList.js